import { Controller } from "@hotwired/stimulus"
import { stimulus } from "../init"

export default class Autosubmit extends Controller {
  connect() {
    console.log("clients searchh");
    this.timeout = null
  }
  
  submit() {
    console.log("clients searchh");
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const event = new Event("submit", { bubbles: true, cancelable: true });
      
      this.element.dispatchEvent(event);
    }, 400)
  }
}

stimulus.register('autosubmit', Autosubmit)